import type { AccountPaySession } from '../api';

const DEV_PAYMENT_H5_BASE_URL = 'http://192.168.123.209:5174/web/payment';
const PROD_PAYMENT_H5_BASE_URL = 'https://fluxmind.omnimind.com.cn/web/payment';
const DEFAULT_PAYMENT_H5_BASE_URL = import.meta.env.DEV
  ? DEV_PAYMENT_H5_BASE_URL
  : PROD_PAYMENT_H5_BASE_URL;

export const PAYMENT_H5_BASE_URL = (
  import.meta.env.VITE_PAYMENT_H5_BASE_URL || DEFAULT_PAYMENT_H5_BASE_URL
).trim().replace(/\/+$/, '');

export function buildPaymentUrl(session?: AccountPaySession | null) {
  const token = session?.paySessionToken;
  if (!token) {
    return '';
  }
  return `${PAYMENT_H5_BASE_URL}?pay_session=${encodeURIComponent(token)}`;
}
